import { ErrorBoundary } from '@/components/feedback/ErrorBoundary'
import { UpdateNotifier } from '@/components/feedback/UpdateNotifier'
import { kidFirstShellEnabled } from '@/content/kid-first'
import { useBadgeToast } from '@/hooks/app/useBadgeToast'
import { useJobEvents } from '@/hooks/app/useJobEvents'
import { AppKitProvider } from '@/providers/AppKitProvider'
import { AppProvider } from '@/providers/AppProvider'
import { AuthProvider } from '@/providers/AuthProvider'
import { JobQueueProvider } from '@/providers/JobQueueProvider'
import { ToastProvider } from '@/providers/ToastProvider'
import { router } from '@/router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router'

// TODO: configure TanStack Query with Dexie persistence, networkMode: 'offlineFirst'
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'offlineFirst',
      staleTime: 1000 * 60 * 5,
      retry: 1,
    },
  },
})

function BadgeToastWatcher() {
  useBadgeToast()
  return null
}

function JobEventWatcher() {
  useJobEvents()
  return null
}

export function App() {
  return (
    <ErrorBoundary>
      <AppKitProvider>
        <AuthProvider>
          <QueryClientProvider client={queryClient}>
            <AppProvider>
              <JobQueueProvider>
                <ToastProvider>
                  <BadgeToastWatcher />
                  <JobEventWatcher />
                  <RouterProvider router={router} />
                  {!kidFirstShellEnabled ? <UpdateNotifier /> : null}
                </ToastProvider>
              </JobQueueProvider>
            </AppProvider>
          </QueryClientProvider>
        </AuthProvider>
      </AppKitProvider>
    </ErrorBoundary>
  )
}
